import { Grid } from "@dealer-center/core-components";
import type { CompareToolContentItemProps } from "./interface";
import { CheckBox } from "@dealer-center/core-components";
export const CompareToolContentItem = ({
  label,
  value
}: CompareToolContentItemProps) => {
  return (
    <Grid size={{ sm: 6 }} sx={{ wordBreak: "break-word" }}>
      {typeof value === "boolean" ? (
        <CheckBox disabled checked={value} label={label} value={label} />
      ) : (
        value
      )}
    </Grid>
  );
};
